let apiUrl: string
let wsUrl: string
let GA_KEY: string
let bigdataUrl: string
let OOPGAMEID = 2
const CHAIN_HASH_URL_MAP: { [key: string]: string } = {
  BSC: 'https://bscscan.com/tx',
  Polygon: 'https://polygonscan.com/tx',
}

const SEARCH_CONTRACT_ADDRESS: { [key: number]: string } = {
  56: '0x37a2f27E7bBf03046826000c639638d4ef2e930a',
  137: '0x9aE4ECE64499CFcAee7FC4508ff373E3A2fa6966',
}

const sensorsConfig = {
  serverUrl: 'https://sc-datasink.ffe390afd658c19dcbf707e0597b846d.de/sa?project=default',
  showLog: false,
}
const host = window.location.host
if (host.includes('.staging.')) {
  GA_KEY = '6Lctqb8gAAAAAAypBindMlQ4atrh9tbiEwG2Ix-h'
  apiUrl = 'https://gameplus-web.staging.davionlabs.com/'
  wsUrl = 'wss://gameplus-web.staging.davionlabs.com/notify/webSocket'
  // apiUrl = 'https://www.yeehagames.com/'
  // wsUrl = 'wss://www.yeehagames.com/notify/webSocket'
  // GA_KEY = '6Lc9u78gAAAAAC9qXZtqTrKuBZuF36G9TiLttdPo'

  bigdataUrl = 'https://gameplus-bg-666.staging.davionlabs.com/log'
} else if (host.includes('.qa.') || host.includes('localhost')) {
  OOPGAMEID = 88
  // apiUrl = 'https://www.yeehagames.com/'
  GA_KEY = '6Lddlo0gAAAAAMe6B2I2GZokRbuKQENArrpEFXgJ'
  apiUrl = 'https://gameplus-web.qa.davionlabs.com/'
  wsUrl = 'wss://gameplus-web.qa.davionlabs.com/notify/webSocket'

  bigdataUrl = 'https://gameplus-bg-666.qa.davionlabs.com/log'
  //bigdataUrl = 'http://localhost:2000'
} else if (host.includes('.dev.')) {
  GA_KEY = '6Lddlo0gAAAAAMe6B2I2GZokRbuKQENArrpEFXgJ'
  apiUrl = 'https://gameplus-web.dev.davionlabs.com/'
  wsUrl = 'wss://gameplus-web.dev.davionlabs.com/notify/webSocket'

  bigdataUrl = 'https://gameplus-bg-666.dev.davionlabs.com/log'
  //bigdataUrl = 'http://localhost:2000'
} else {
  GA_KEY = '6Lc9u78gAAAAAC9qXZtqTrKuBZuF36G9TiLttdPo'
  apiUrl = '/'
  wsUrl = 'wss://yeehagames.com/notify/webSocket'
  sensorsConfig.serverUrl = 'https://sc-datasink.ffe390afd658c19dcbf707e0597b846d.de/sa?project=yeeha_game'
  sensorsConfig.showLog = false

  bigdataUrl = 'https://bigdata-log.yeehagames.com'
}

export { SEARCH_CONTRACT_ADDRESS, apiUrl, sensorsConfig, wsUrl, CHAIN_HASH_URL_MAP, GA_KEY, bigdataUrl, OOPGAMEID }
export const HOST = window.location.origin
